window.customElements.define('lazyloaded-video',
  class LazyLoadedVideo extends HTMLElement {
    connectedCallback() {
      this.observer = null;
      this.video = this.querySelector('video');
      this.initObserver();
    }

    initObserver() {
      if (!this.video) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        });

        this.observer.observe(this.video);
      } else {
        this.loadVideo(this.video);
      }
    }

    loadVideo(video) {
      video.addEventListener('canplay', () => {
        this.onVideoReady(video);
      }, { once: true });

      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        source.src = source.dataset.src;
      });
      
      video.load();
    }

    onVideoReady(video) {
      this.classList.remove('lazy');
      this.classList.add('loaded');
      this.playVideo(video);
    }

    playVideo(video) {
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.removeInteractionListeners();
          })
          .catch(() => {
            this.setupUserInteractionPlay(video);
          });
      }
    }

    setupUserInteractionPlay(video) {
      this.interactionHandler = () => {
        video.play().catch(() => {});
        this.removeInteractionListeners();
      };

      document.addEventListener('touchstart', this.interactionHandler, { passive: true });
      document.addEventListener('click', this.interactionHandler, { passive: true });
      document.addEventListener('scroll', this.interactionHandler, { passive: true });
    }

    removeInteractionListeners() {
      if (this.interactionHandler) {
        document.removeEventListener('touchstart', this.interactionHandler);
        document.removeEventListener('click', this.interactionHandler);
        document.removeEventListener('scroll', this.interactionHandler);
        this.interactionHandler = null;
      }
    }

    disconnectedCallback() {
      this.removeInteractionListeners();
    }
  }
);
